// ABOUTME: Explains WhatsApp application flow settings in recruiter-facing language.
// ABOUTME: Keeps the flow editor usable when configuration fields are not self-evident.
import React from "react";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";

import { whatsappPreRegistrationTemplatePlaceholderValues } from "./whatsappPreRegistrationTemplatePlaceholderValues";

interface IWhatsappApplicationHelpDialog {
    t: any;
    open: boolean;
    scope?: "JOB" | "PRE_REGISTRATION";
    onClose: () => void;
}

const jobHelpItemKeys = [
    "whatsappApplicationHelpLink",
    "whatsappApplicationHelpModel",
    "whatsappApplicationHelpRequiredFields",
    "whatsappApplicationHelpScreeningQuestionnaire",
    "whatsappApplicationHelpAutomaticMessages",
    "whatsappApplicationHelpCvMessages",
    "whatsappApplicationHelpStages",
    "whatsappApplicationHelpNodes",
    "whatsappApplicationHelpNextNode",
    "whatsappApplicationHelpAnswerKey",
    "whatsappApplicationHelpOptions",
    "whatsappApplicationHelpConditions",
    "whatsappApplicationHelpScore",
    "whatsappApplicationHelpEliminatory",
    "whatsappApplicationHelpPublish"
];

const preRegistrationHelpItemKeys = [
    "whatsappPreRegistrationHelpModel",
    "whatsappPreRegistrationHelpAutomaticMessages",
    "whatsappApplicationHelpCvMessages",
    "whatsappPreRegistrationHelpNodes",
    "whatsappApplicationHelpNextNode",
    "whatsappApplicationHelpAnswerKey",
    "whatsappApplicationHelpOptions",
    "whatsappApplicationHelpConditions",
    "whatsappApplicationHelpScore",
    "whatsappApplicationHelpEliminatory"
];

const WhatsappApplicationHelpDialog = (
    props: IWhatsappApplicationHelpDialog
) => {
    const { t, open, scope = "JOB", onClose } = props;
    const preRegistration = scope === "PRE_REGISTRATION";
    const helpItemKeys = preRegistration
        ? preRegistrationHelpItemKeys
        : jobHelpItemKeys;

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            aria-labelledby="whatsapp-application-help-title"
        >
            <DialogTitle id="whatsapp-application-help-title">
                {t(
                    preRegistration
                        ? "whatsappPreRegistrationHelpTitle"
                        : "whatsappApplicationHelpTitle"
                )}
            </DialogTitle>
            <DialogContent dividers>
                <Typography variant="body2" paragraph>
                    {t(
                        preRegistration
                            ? "whatsappPreRegistrationHelpIntro"
                            : "whatsappApplicationHelpIntro"
                    )}
                </Typography>
                {helpItemKeys.map((key) => (
                    <Box key={key} marginBottom={1.5}>
                        <Typography variant="body2">
                            {t(
                                key,
                                key ===
                                    "whatsappPreRegistrationHelpAutomaticMessages"
                                    ? whatsappPreRegistrationTemplatePlaceholderValues
                                    : undefined
                            )}
                        </Typography>
                    </Box>
                ))}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    {t("whatsappApplicationClose")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default WhatsappApplicationHelpDialog;
